import { render, staticRenderFns } from "./TestTry2.vue?vue&type=template&id=12edb3d8"
import script from "./TestTry2.vue?vue&type=script&lang=js"
export * from "./TestTry2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports